var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "baseInfoManage",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-width": "135px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("table.areaGroupIdName"),
                        prop: "upIdList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.options,
                          "change-on-select": "",
                          props: _vm.propstree
                        },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "单位名称", prop: "companyAccountName" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          maxlength: "50",
                          clearable: "",
                          type: "text",
                          placeholder: "请输入单位名称"
                        },
                        model: {
                          value: _vm.childData.companyAccountName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "companyAccountName", $$v)
                          },
                          expression: "childData.companyAccountName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位简称", prop: "companySimpleName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          maxlength: "50",
                          clearable: "",
                          type: "text",
                          placeholder: "请输入单位简称"
                        },
                        model: {
                          value: _vm.childData.companySimpleName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "companySimpleName", $$v)
                          },
                          expression: "childData.companySimpleName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开业时间" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "请选择开业时间",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.openDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "openDate", $$v)
                          },
                          expression: "childData.openDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "行业类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择行业类型",
                            clearable: ""
                          },
                          model: {
                            value: _vm.childData.industryType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "industryType", $$v)
                            },
                            expression: "childData.industryType"
                          }
                        },
                        _vm._l(_vm.industryTypeList, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择单位类型",
                            clearable: ""
                          },
                          model: {
                            value: _vm.childData.companyType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "companyType", $$v)
                            },
                            expression: "childData.companyType"
                          }
                        },
                        _vm._l(_vm.companyTypeList, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "管理级别" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择管理级别",
                            clearable: ""
                          },
                          model: {
                            value: _vm.childData.managementLevel,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "managementLevel", $$v)
                            },
                            expression: "childData.managementLevel"
                          }
                        },
                        _vm._l(_vm.managementLevelList, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "统一社会信用代码",
                        prop: "companyCreditCode"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          maxlength: "30",
                          placeholder: "请输入统一社会信用代码"
                        },
                        model: {
                          value: _vm.childData.companyCreditCode,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "companyCreditCode", $$v)
                          },
                          expression: "childData.companyCreditCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "法人代表", prop: "companyLegal" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          maxlength: "40",
                          placeholder: "请输入法人代表"
                        },
                        model: {
                          value: _vm.childData.companyLegal,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "companyLegal", $$v)
                          },
                          expression: "childData.companyLegal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "管理员", prop: "admin" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          maxlength: "40",
                          placeholder: "请输入管理员"
                        },
                        model: {
                          value: _vm.childData.admin,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "admin", $$v)
                          },
                          expression: "childData.admin"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话", prop: "legalPhoneOne" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          maxlength: "20",
                          placeholder: "请输入联系电话"
                        },
                        model: {
                          value: _vm.childData.legalPhoneOne,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "legalPhoneOne", $$v)
                          },
                          expression: "childData.legalPhoneOne"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "起租时间", prop: "rentTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "请选择起租时间",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.rentTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "rentTime", $$v)
                          },
                          expression: "childData.rentTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "到租时间", prop: "unRentTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "请选择到租时间",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.unRentTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "unRentTime", $$v)
                          },
                          expression: "childData.unRentTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "租赁房屋地址" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: true, type: "text" },
                        model: {
                          value: _vm.fangwu,
                          callback: function($$v) {
                            _vm.fangwu = $$v
                          },
                          expression: "fangwu"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticStyle: {},
                        attrs: {
                          maxlength: "200",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择租赁房屋地址",
            visible: _vm.dialogAllotFormVisible,
            width: "430px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAllotFormVisible = $event
            }
          }
        },
        [
          _c("allocateHouses", {
            attrs: {
              "role-id": _vm.roleId,
              "checked-nodes": _vm.checkedTreesNodes,
              "show-dialog": _vm.dialogAllotFormVisible
            },
            on: { getTreeData: _vm.getTreeData, handCancle11: _vm.handCancle11 }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }